import React, { Component } from 'react';
import * as PropTypes from 'prop-types';
import { Card, Button, ButtonGroup, Form } from 'react-bootstrap';
import {
  faExclamationTriangle,
  faPencil,
  faSave,
  faSpinnerThird,
  faTimes,
} from '@whitebox-learning/fontawesome-pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useForm, Controller } from 'react-hook-form';
import { EditIcon, SaveIcon, CancelIcon } from './Icons';
import './EditableTextarea.scss';

const EditableTextarea = ({ title, content, save, identifier, ...rest }) => {
  const editableId = `editable-${identifier}`;
  const [editing, setEditing] = React.useState(false);
  const { control, handleSubmit } = useForm({
    defaultValues: { [editableId]: content || '' },
  });

  const handleSaveContent = (data) => {
    if (data[editableId]) {
      Promise.resolve(save(identifier, data[editableId])).then(() => {
        setEditing(false);
      });
    }
  };

  return (
    <Form {...rest} onSubmit={handleSubmit(handleSaveContent)}>
      <Card className="h-100">
        <Card.Header>
          <Card.Title>{title}</Card.Title>
        </Card.Header>
        <Card.Body className="p-1 overflow-auto">
          {editing ? (
            <Controller
              name={editableId}
              control={control}
              render={({ field }) => (
                <Form.Control as="textarea" className="h-100" {...field} />
              )}
            />
          ) : (
            <div className="p-2">{content}</div>
          )}
        </Card.Body>
        <Card.Footer>
          {editing ? (
            <ButtonGroup size="sm">
              <Button type="submit">
                <SaveIcon /> Save
              </Button>
              <Button variant="secondary" onClick={() => setEditing(false)}>
                <CancelIcon /> Cancel
              </Button>
            </ButtonGroup>
          ) : (
            <Button
              size="sm"
              variant="secondary"
              onClick={() => setEditing(true)}
            >
              <EditIcon /> Edit
            </Button>
          )}
        </Card.Footer>
      </Card>
    </Form>
  );
};

EditableTextarea.defaultProps = {
  content: '',
};
EditableTextarea.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  content: PropTypes.string,
  save: PropTypes.func.isRequired,
  identifier: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
};

export default EditableTextarea;
